(function () {
    if (document.querySelector('.open_collections')) {
        const openBtn = document.querySelector('.open_collections')
        const closeBtn = document.querySelector('.all_collections_drawer__close')
        const overlay = document.querySelector('.all_collections_drawer__overlay')

        openBtn.addEventListener('click', (e) => {
            e.preventDefault() 
            document.querySelector('.all_collections_drawer').classList.add('active')
        })
        closeBtn.addEventListener('click', () => {
            document.querySelector('.all_collections_drawer').classList.remove('active')
        })
        overlay.addEventListener('click', () => {
            document.querySelector('.all_collections_drawer').classList.remove('active')
        })
    }
})();

// share button
(function () {
    if (document.getElementById('shareButton')) {
        document.getElementById('shareButton').addEventListener('click', async () => {
            if (navigator.share) {
              try {
                await navigator.share({
                  title: 'glovesinabottle.com',
                  text: 'Check out this amazing content!',
                  url: window.location.href
                });
                console.log('Content shared successfully');
              } catch (error) {
                console.error('Error sharing content: ', error);
              }
            } else {
              // Fallback for browsers that do not support the Web Share API
              alert('Web Share API is not supported in your browser.');
            }
          });
    }
    
})();
// share button